// @ts-check

import React from 'react';

import Paper from '@liquidweb-dev/undercurrent/Paper';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** @param {import('@liquidweb-dev/undercurrent/Paper').PaperProps} props */
const RestrictionPaper = ({ sx, ...rest }) => (
	<Paper
		sx={combineSx(
			{
				padding: 500,
				display: 'flex',
				flexDirection: 'column',
				gap: 300,
				maxWidth: '520px',
				borderRadius: ({ borderRadius }) => borderRadius.roundedSm,
			},
			sx,
		)}
		elevation={2}
		{...rest}
	/>
);

export default RestrictionPaper;
